import cn from 'clsx';
import PropTypes from 'prop-types';
import { Icon } from '@/components/atom';
import styles from './iconButton.module.less';
import { jsx as _jsx } from "react/jsx-runtime";
export default function IconButton({
  color,
  className,
  name,
  ...restProps
}) {
  return /*#__PURE__*/_jsx("button", {
    className: `${cn(styles.iconBtn, {
      [styles[`iconBtn--${color}`]]: color
    }, className)}`,
    ...restProps,
    children: /*#__PURE__*/_jsx(Icon, {
      name: name
    })
  });
}
IconButton.propTypes = {
  color: PropTypes.oneOf(['danger', 'success']),
  name: PropTypes.string.isRequired,
  className: PropTypes.string
};